// Form validation for New credential form
import { plaintextValidator } from '../fields';

const config = { mandatory: true, customError: `^ Required` };

export default {
  clientId: plaintextValidator(config),
  siteId: plaintextValidator(config),
  outputType: plaintextValidator(config),
  subnets: function(value, attributes, attributeName, options, constraints) {
    if (attributes.outputType === 'subnets') {
      return {
        array: {
          ip: {
            regexChecker: {
              regex: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
              mandatory: true,
              field: 'IP Address'
            }
          },
          mask: {
            presence: {
              allowEmpty: false
            },
            numericality: {
              greaterThanOrEqualTo: 16,
              lessThanOrEqualTo: 32
            }
          }
        }
      };
    }

    if (attributes.outputType === 'manualIp') {
      return {
        array: {
          ip: {
            regexChecker: {
              regex: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
              mandatory: true,
              field: 'IP Address'
            }
          }
        }
      };
    }

    return null;
  }
};
